module.exports = __webpack_public_path__ + "statics/img/cate5-3@2x.337968b7.png";